export enum ROLES {
  USER = "User",
  SUPER_ADMIN = "Super Admin",
  DOCTOR = "Doctor",
}
